var antLoader = function(fn) {
    if (typeof window.AlipayJSBridge !== 'undefined') {
        fn(window.AlipayJSBridge);
    } else {
        document.addEventListener('AlipayJSBridgeReady', function() {
            fn(window.AlipayJSBridge);
        });
    }
};
export default antLoader;
